import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Modal from '../../../../common/modal/Modal';
import Checkbox from '../../../../common/inputs/checkbox/Checkbox';
import Button from '../../../../common/button/Button';

import './role-modal.scss';

const RoleModal = ({ show, setShow, staffMember, setStaffMember, updateRoles }) => {
  const [administrator, setAdministrator] = useState(false);
  const [facilitator, setFacilitator] = useState(false);

  useEffect(() => {
    if (staffMember?.role === 'admin') {
      setAdministrator(true);
    } else if (staffMember?.role === 'facilitator') {
      setFacilitator(true);
    }
  }, [staffMember]);

  const handleChange = (role) => {
    if (role === 'admin') {
      setAdministrator(true);
      setFacilitator(false);
    } else if (role === 'facilitator') {
      setAdministrator(false);
      setFacilitator(true);
    }
  };

  const closeModal = () => {
    setAdministrator(false);
    setFacilitator(false);
    setShow(false);
    setStaffMember(undefined);
  };

  const handleSaveClick = () => {
    const roles = {
      administrator,
      facilitator,
    };

    updateRoles(staffMember.personExternalReference, roles, closeModal);
  };

  if (!staffMember) return null;

  return (
    <Modal show={show} onClose={closeModal}>
      <div className="role-modal">
        <p className="role-modal__title">{staffMember.member}</p>
        <p className="role-modal__subtitle">{staffMember.username}</p>

        <div className="role-modal__roles">
          <div className="role-modal__role">
            <Checkbox name="admin" value={administrator} onChange={() => handleChange('admin')} />
            <label className="role-modal__label" htmlFor="admin">
              Administrator
            </label>
          </div>
          <div className="role-modal__role">
            <Checkbox name="facilitator" value={facilitator} onChange={() => handleChange('facilitator')} />
            <label className="role-modal__label" htmlFor="facilitator">
              Facilitator
            </label>
          </div>
        </div>

        {(administrator || facilitator) && (
          <div className="role-modal__description">
            {administrator && <p>Full rights, can make any changes.</p>}
            {facilitator && <p>Can facilitate Deals, read and reply to support messages.</p>}
          </div>
        )}

        <div className="role-modal__buttons">
          <Button className="role-modal__button" onClick={closeModal} secondary>
            Cancel
          </Button>
          <Button className="role-modal__button" onClick={handleSaveClick}>
            Save Changes
          </Button>
        </div>
      </div>
    </Modal>
  );
};

RoleModal.propTypes = {
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  staffMember: PropTypes.object,
  setStaffMember: PropTypes.func.isRequired,
  updateRoles: PropTypes.func.isRequired,
};

RoleModal.defaultProps = {
  staffMember: undefined,
};

export default RoleModal;
